// Creative Canvas Labs — theme.js
// Cart drawer + quick add + qty handlers + PDP enhancements. Uses Shopify Ajax Cart API.

(function () {
  const drawer = document.querySelector('[data-cart-drawer]');

  // Every cart badge (mobile header, desktop header, mobile-nav) carries
  // [data-cart-count]; re-query on each write so re-rendered nodes are covered.
  function setCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.remove('is-updated');
      void el.offsetHeight; // restart the pulse animation
      el.classList.add('is-updated');
    });
  }

  // ── Drawer open/close (animated) ──────────────────────────────────────────

  function animateOpen(el) {
    if (!el) return;
    el.hidden = false;
    el.classList.add('is-open');
    var panel = el.querySelector('.mobile-nav-panel, .cart-drawer, .filter-drawer-panel');
    if (panel) {
      // Force inline transform after a paint tick — covers cases where visibility changes block the CSS transition
      setTimeout(function () {
        panel.style.transform = 'translateX(0)';
      }, 16);
    }
    trapFocus(el);
  }

  function animateClose(el) {
    if (!el) return;
    el.classList.remove('is-open');
    var panel = el.querySelector('.mobile-nav-panel, .cart-drawer, .filter-drawer-panel');
    if (panel) {
      panel.style.transform = '';  // revert to CSS default (off-screen)
    }
    releaseFocus(el);
    // Fallback for hidden state — keep DOM tractable
    setTimeout(function () { el.hidden = true; }, 350);
  }

  function openDrawer() { hydrateCartRecs(drawer); animateOpen(drawer); }
  function closeDrawer() { animateClose(drawer); }
  function openPanel(sel) { animateOpen(document.querySelector(sel)); }
  function closePanel(sel) { animateClose(document.querySelector(sel)); }

  // ── Focus trap ──────────────────────────────────────────────────────────────

  function trapFocus(container) {
    const focusable = Array.from(
      container.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])')
    );
    if (!focusable.length) return;
    focusable[0].focus();
    container._trapHandler = function (e) {
      if (e.key !== 'Tab') return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    };
    container.addEventListener('keydown', container._trapHandler);
  }

  function releaseFocus(container) {
    if (container && container._trapHandler) {
      container.removeEventListener('keydown', container._trapHandler);
      delete container._trapHandler;
    }
  }

  // Escape closes any open drawer
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && !drawer.hidden) closeDrawer();
    var fd = document.querySelector('[data-filter-drawer]');
    if (fd && !fd.hidden) animateClose(fd);
    var mn = document.querySelector('[data-mobile-nav]');
    if (mn && !mn.hidden) animateClose(mn);
  });

  // ── Click delegation ────────────────────────────────────────────────────────

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }
    if (e.target.closest('[data-filter-open]')) { e.preventDefault(); openPanel('[data-filter-drawer]'); }
    if (e.target.closest('[data-filter-close]')) { e.preventDefault(); closePanel('[data-filter-drawer]'); }
    if (e.target.closest('[data-mobile-open]')) { e.preventDefault(); openPanel('[data-mobile-nav]'); }
    if (e.target.closest('[data-mobile-close]')) { e.preventDefault(); closePanel('[data-mobile-nav]'); }

    // PDP thumbnail gallery
    var thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      var idx = thumb.getAttribute('data-thumb');
      var gallery = thumb.closest('[data-pdp-gallery]');
      if (gallery) {
        gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        gallery.querySelectorAll('[data-stage]').forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-stage') === idx); });
      }
    }

    // X-sell size picker — reveal the chip row, closing any other open picker in the grid
    var pick = e.target.closest('[data-xsell-pick]');
    if (pick) {
      e.preventDefault();
      var xcard = pick.closest('[data-xsell-card]');
      var xlist = xcard && xcard.querySelector('[data-xsell-variants]');
      if (xlist) {
        var willOpen = xlist.hidden;
        var xgrid = pick.closest('.cart-xsell-grid');
        if (xgrid) {
          xgrid.querySelectorAll('[data-xsell-variants]').forEach(function (l) { l.hidden = true; });
          xgrid.querySelectorAll('[data-xsell-pick]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        }
        xlist.hidden = !willOpen;
        pick.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      }
    }

    // Cart item remove (Ajax)
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); changeCartItem(rm.getAttribute('data-cart-remove'), 0); }
  });

  // ── Button feedback helper ─────────────────────────────────────────────────

  function btnFeedback(btn, state, text, duration) {
    if (!btn) return;
    btn.classList.remove('is-adding', 'is-added', 'is-error');
    btn.classList.add(state);
    var orig = btn._origText || btn.textContent;
    if (!btn._origText) btn._origText = orig;
    btn.textContent = text;
    if (duration) {
      setTimeout(function () {
        btn.classList.remove('is-adding', 'is-added', 'is-error');
        btn.textContent = btn._origText;
        btn.disabled = false;
        delete btn._origText;
      }, duration);
    }
  }

  // ── Quick add ───────────────────────────────────────────────────────────────

  document.addEventListener('click', async function (e) {
    var quick = e.target.closest('[data-quick-add]');
    if (!quick) return;
    e.preventDefault();
    if (parseInt(quick.getAttribute('data-variant-count') || '1', 10) > 1) {
      window.location.href = quick.getAttribute('data-product-url');
      return;
    }
    var id = quick.getAttribute('data-quick-add');
    quick.disabled = true;
    btnFeedback(quick, 'is-adding', 'Adding…');
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
      });
      if (!res.ok) throw new Error(await res.text());
      await refreshCartDrawer();
      btnFeedback(quick, 'is-added', 'Added ✓', 1400);
      openDrawer();
    } catch (err) {
      btnFeedback(quick, 'is-error', 'Error', 1400);
      console.error(err);
    }
  });

  // ── Qty + / - (in-place, no reload) ────────────────────────────────────────

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-qty-up], [data-qty-down]');
    if (!btn) return;
    var key = btn.dataset.key;
    var input = drawer && drawer.querySelector('input[data-key="' + key + '"]');
    if (!input) return;
    var dir = btn.matches('[data-qty-up]') ? 1 : -1;
    var next = Math.max(0, parseInt(input.value, 10) + dir);
    btn.disabled = true;
    await changeCartItem(key, next);
    btn.disabled = false;
  });

  // Manual qty input change
  document.addEventListener('change', async function (e) {
    if (!e.target.matches('input[name="updates[]"][data-key]')) return;
    var key = e.target.getAttribute('data-key');
    var next = Math.max(0, parseInt(e.target.value, 10) || 0);
    await changeCartItem(key, next);
  });

  // ── "Add the full look" ─────────────────────────────────────────────────────

  document.addEventListener('click', async function (e) {
    var fullLook = e.target.closest('[data-add-full-look]');
    if (!fullLook) return;
    e.preventDefault();
    var ids = (fullLook.getAttribute('data-add-full-look') || '').split(',').filter(Boolean);
    if (!ids.length) return;
    fullLook.disabled = true;
    btnFeedback(fullLook, 'is-adding', 'Adding…');
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) }),
      });
      if (!res.ok) throw new Error(await res.text());
      await refreshCartDrawer();
      btnFeedback(fullLook, 'is-added', 'Added ✓', 2000);
      openDrawer();
    } catch (err) {
      btnFeedback(fullLook, 'is-error', 'Error — try again', 2000);
      console.error(err);
    }
  });

  // ── PDP option completeness check ──────────────────────────────────────────
  // Builds the selected-options map exactly as the option-button click handler
  // does, and returns the first option group with no selection (or null if all
  // groups have a selection). On failure also surfaces the inline error UI.
  function firstUnselectedOption(form) {
    if (!form) return null;
    var firstMissing = null;
    form.querySelectorAll('.pdp-option').forEach(function (opt) {
      if (firstMissing) return;
      var active = opt.querySelector('.pdp-option-btn.is-active');
      if (!active) firstMissing = opt;
    });
    return firstMissing;
  }

  function flagMissingOption(form, missing) {
    var err = form.querySelector('[data-pdp-error]');
    if (err) {
      err.removeAttribute('hidden');
      err.textContent = 'Select a size to continue';
    }
    if (missing) {
      var btn = missing.querySelector('.pdp-option-btn:not(.is-disabled)') || missing.querySelector('.pdp-option-btn');
      if (btn) btn.focus();
    }
  }

  // ── Mobile sticky CTA → delegates click to main PDP form ───────────────────

  document.addEventListener('click', function (e) {
    var mobileAdd = e.target.closest('[data-pdp-mobile-add]');
    if (!mobileAdd) return;
    var form = document.querySelector('.pdp-form');
    if (!form) return;
    var submit = form.querySelector('.pdp-add');
    // Sold out (or an add already in flight): requestSubmit() ignores a disabled
    // submitter, so guard here instead of POSTing a 422 to /cart/add.js.
    if (mobileAdd.disabled || (submit && submit.disabled)) return;
    var missing = firstUnselectedOption(form);
    if (missing) { flagMissingOption(form, missing); return; }
    if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
  });

  // Auto-hide mobile CTA when the desktop add-to-cart button is in viewport
  (function () {
    var pdpSubmit = document.querySelector('.pdp-form button[type="submit"]');
    var mobileCta = document.querySelector('[data-pdp-mobile-cta]');
    if (!pdpSubmit || !mobileCta) return;
    // aria-hidden is owned here (not hardcoded in Liquid) so it is only true
    // while the bar is actually suppressed behind the in-view desktop button.
    function setHidden(hidden) {
      mobileCta.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      mobileCta.style.pointerEvents = hidden ? 'none' : '';
    }
    setHidden(false);
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      setHidden(entries[0].isIntersecting);
    }, { threshold: 0.5 }).observe(pdpSubmit);
  }());

  // ── PDP form — AJAX submit → open cart drawer ───────────────────────────────

  document.addEventListener('submit', async function (e) {
    var form = e.target.closest('.pdp-form');
    if (!form) return;
    e.preventDefault();
    // Completeness check — every option group must have a selection
    var missing = firstUnselectedOption(form);
    if (missing) { flagMissingOption(form, missing); return; }
    var submit = form.querySelector('button[type="submit"]');
    var stickyBtn = document.querySelector('[data-pdp-mobile-add]'); // mobile sticky mirror
    submit.disabled = true;
    btnFeedback(submit, 'is-adding', 'Adding…');
    if (stickyBtn) { stickyBtn.disabled = true; btnFeedback(stickyBtn, 'is-adding', 'Adding…'); }
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!res.ok) throw new Error(await res.text());
      await refreshCartDrawer();
      btnFeedback(submit, 'is-added', 'Added ✓', 1500);
      if (stickyBtn) btnFeedback(stickyBtn, 'is-added', 'Added ✓', 1500);
      openDrawer();
    } catch (err) {
      console.error(err);
      btnFeedback(submit, 'is-error', 'Error — try again', 1500);
      if (stickyBtn) btnFeedback(stickyBtn, 'is-error', 'Error — try again', 1500);
    }
  });

  // ── Cart helpers ────────────────────────────────────────────────────────────

  async function changeCartItem(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    });
    await refreshCartDrawer();
  }

  var _cartRefreshing = false;
  async function refreshCartDrawer() {
    if (!drawer || _cartRefreshing) return;
    _cartRefreshing = true;
    drawer.classList.add('is-loading');
    try {
      var res = await fetch('/?sections=cart-drawer');
      if (res.ok) {
        var data = await res.json();
        var html = data['cart-drawer'];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer]');
          if (fresh) {
            var wasOpen = drawer.classList.contains('is-open');
            drawer.innerHTML = fresh.innerHTML;
            drawer.hidden = false;
            if (wasOpen) drawer.classList.add('is-open');
            hydrateCartRecs(drawer); // fresh placeholder → refetch recs with the new seed + exclusions
          }
        }
      }
      var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      setCartCount(cart.item_count);
      await refreshCartPage(); // no-op everywhere except /cart
    } catch (err) {
      console.error('Cart refresh error:', err);
    } finally {
      _cartRefreshing = false;
      drawer.classList.remove('is-loading');
    }
  }

  // ── Cart recommendations ("you may also like") ─────────────────────────────
  // Placeholders ([data-cart-recs]) carry a pre-built /recommendations/products
  // URL rendered by sections/cart-recommendations.liquid, which excludes in-cart
  // products and falls back to collections server-side. Idempotent per element.

  function hydrateCartRecs(scope) {
    var els = (scope || document).querySelectorAll('[data-cart-recs]:not([data-recs-loaded])');
    els.forEach(function (el) {
      var url = el.getAttribute('data-recs-url');
      if (!url) { el.hidden = true; return; }
      el.setAttribute('data-recs-loaded', '1');
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('recs ' + r.status)); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('[data-cart-recs-content]');
          var cards = content ? content.querySelectorAll('[data-xsell-card]') : [];
          if (!cards.length) throw new Error('empty');
          var limit = parseInt(el.getAttribute('data-limit') || '3', 10);
          for (var i = limit; i < cards.length; i++) cards[i].remove();
          el.innerHTML = content.innerHTML;
        })
        .catch(function () {
          var wrap = el.closest('[data-cart-recs-wrap]');
          (wrap || el).hidden = true;
        });
    });
  }

  async function refreshCartPage() {
    var page = document.querySelector('[data-cart-page]');
    if (!page) return;
    // Don't clobber the page while the user is mid-edit in a qty/note field
    if (page.contains(document.activeElement) && document.activeElement.matches('input, textarea')) return;
    try {
      var res = await fetch('/cart?section_id=main-cart');
      if (!res.ok) return;
      var doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      var fresh = doc.querySelector('[data-cart-page]');
      if (fresh) {
        page.replaceWith(fresh);
        hydrateCartRecs(fresh);
      }
    } catch (err) {
      console.error('Cart page refresh error:', err);
    }
  }

  // Cart page recs strip hydrates on load; the drawer's hydrates lazily on open
  var cartPageEl = document.querySelector('[data-cart-page]');
  if (cartPageEl) hydrateCartRecs(cartPageEl);

  // ── PDP image lightbox (click main image → fullscreen, click to zoom + pan) ──
  (function () {
    var lb = document.querySelector('[data-pdp-lightbox]');
    if (!lb) return;
    // Move to <body> so fixed positioning covers the sticky header (escapes any stacking context)
    if (lb.parentElement !== document.body) document.body.appendChild(lb);
    var stage = lb.querySelector('[data-lightbox-stage]');
    var img = lb.querySelector('[data-lightbox-img]');
    var counter = lb.querySelector('[data-lightbox-counter]');
    var ZOOM = 2.5;
    var slides = [], current = 0, zoomed = false;

    function collect() {
      slides = Array.prototype.map.call(
        document.querySelectorAll('.pdp-media[data-zoom-src]'),
        function (f) { return { src: f.getAttribute('data-zoom-src'), alt: f.getAttribute('data-zoom-alt') || '' }; }
      );
    }
    function show(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      resetZoom();
      img.src = slides[current].src;
      img.alt = slides[current].alt;
      if (counter) counter.textContent = (current + 1) + ' / ' + slides.length;
    }
    function open(i) {
      collect();
      if (!slides.length) return;
      lb.classList.add('is-open');
      lb.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      show(i);
    }
    function close() {
      lb.classList.remove('is-open');
      lb.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      resetZoom();
    }
    function resetZoom() {
      zoomed = false;
      lb.classList.remove('is-zoomed');
      img.style.transform = 'translate(0,0) scale(1)';
    }
    function panTo(clientX, clientY) {
      var r = stage.getBoundingClientRect();
      var fx = Math.min(1, Math.max(0, (clientX - r.left) / r.width));
      var fy = Math.min(1, Math.max(0, (clientY - r.top) / r.height));
      var panX = (0.5 - fx) * (ZOOM - 1) * img.clientWidth;
      var panY = (0.5 - fy) * (ZOOM - 1) * img.clientHeight;
      img.style.transform = 'translate(' + panX.toFixed(1) + 'px,' + panY.toFixed(1) + 'px) scale(' + ZOOM + ')';
    }

    // Distinguish a deliberate tap from a scroll swipe (so scrolling over the
    // image on touch devices never opens the lightbox / locks the page)
    var tStartX = 0, tStartY = 0, tMoved = false;
    document.addEventListener('touchstart', function (e) {
      if (!e.touches || !e.touches[0]) return;
      tMoved = false; tStartX = e.touches[0].clientX; tStartY = e.touches[0].clientY;
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      if (!e.touches || !e.touches[0]) return;
      if (Math.abs(e.touches[0].clientX - tStartX) > 10 || Math.abs(e.touches[0].clientY - tStartY) > 10) tMoved = true;
    }, { passive: true });

    // Open from the active main image
    document.addEventListener('click', function (e) {
      var media = e.target.closest('.pdp-media.is-active');
      if (!media) return;
      if (!media.hasAttribute('data-zoom-src')) return; // video stage — nothing to zoom
      if (tMoved) return; // gesture was a scroll, not a tap — don't open
      e.preventDefault();
      var gallery = media.closest('[data-pdp-gallery]');
      var all = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('.pdp-media[data-zoom-src]')) : [];
      var idx = all.indexOf(media);
      open(idx < 0 ? 0 : idx);
    });

    // Toggle zoom on the lightbox image
    img.addEventListener('click', function (e) {
      e.stopPropagation();
      zoomed = !zoomed;
      lb.classList.toggle('is-zoomed', zoomed);
      if (zoomed) panTo(e.clientX, e.clientY); else resetZoom();
    });
    // Pan while zoomed (mouse + touch drag)
    stage.addEventListener('pointermove', function (e) {
      if (zoomed) panTo(e.clientX, e.clientY);
    });
    // Click backdrop (not the image) closes
    stage.addEventListener('click', function (e) {
      if (e.target === stage) close();
    });

    lb.querySelector('[data-lightbox-close]').addEventListener('click', close);
    lb.querySelector('[data-lightbox-prev]').addEventListener('click', function (e) { e.stopPropagation(); show(current - 1); });
    lb.querySelector('[data-lightbox-next]').addEventListener('click', function (e) { e.stopPropagation(); show(current + 1); });

    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(current - 1);
      else if (e.key === 'ArrowRight') show(current + 1);
    });
  })();

})();

// ── Dropdown nav ─────────────────────────────────────────────────────────────
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nav-dropdown]');
    if (btn) {
      var item = btn.closest('.hdr-nav-item');
      var wasOpen = item && item.classList.contains('is-open');
      document.querySelectorAll('.hdr-nav-item.is-open').forEach(function (el) {
        el.classList.remove('is-open');
        var b = el.querySelector('[data-nav-dropdown]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (item && !wasOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    if (!e.target.closest('.hdr-nav-item')) {
      document.querySelectorAll('.hdr-nav-item.is-open').forEach(function (el) {
        el.classList.remove('is-open');
        var b = el.querySelector('[data-nav-dropdown]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.hdr-nav-item.is-open').forEach(function (el) {
        el.classList.remove('is-open');
        var b = el.querySelector('[data-nav-dropdown]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
  });
}());

// ── Predictive search ─────────────────────────────────────────────────────────
(function () {
  var toggle = document.querySelector('[data-search-toggle]');
  var panel = document.querySelector('[data-search-panel]');

  function clearResults(results) {
    results.innerHTML = '';
    results.classList.remove('has-results');
  }

  function bindSearch(widget) {
    var input = widget.querySelector('[data-search-input]');
    var results = widget.querySelector('[data-search-results]');
    if (!input || !results) return;

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-search-widget]') && !e.target.closest('[data-search-toggle]')) {
        clearResults(results);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && results.classList.contains('has-results')) {
        clearResults(results);
        input.blur();
      }
    });

    var searchTimer;
    input.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = input.value.trim();
      if (q.length < 2) {
        clearResults(results);
        return;
      }
      searchTimer = setTimeout(async function () {
        try {
          var res = await fetch(
            '/search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=5'
          );
          if (!res.ok) return;
          var data = await res.json();
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) {
            results.innerHTML = '<div class="hdr-search-empty">No results for “' + q + '”</div>';
          } else {
            results.innerHTML = products.map(function (p) {
              var imgSrc = p.featured_image && p.featured_image.url
                ? p.featured_image.url + '&width=112'
                : '';
              var price = p.price ? '$' + parseFloat(p.price).toFixed(2) : '';
              return '<a href="' + p.url + '" class="hdr-search-result">' +
                (imgSrc ? '<img src="' + imgSrc + '" alt="" width="56" height="56" loading="lazy">' : '<div style="width:56px;height:56px;background:var(--paper);"></div>') +
                '<div><div class="hdr-search-result-title">' + p.title + '</div>' +
                '<div class="hdr-search-result-price">' + price + '</div></div>' +
                '</a>';
            }).join('');
          }
          results.classList.add('has-results');
        } catch (err) {
          console.error('Search error:', err);
        }
      }, 260);
    });
  }

  document.querySelectorAll('[data-search-widget]').forEach(bindSearch);

  if (toggle && panel) {
    var panelInput = panel.querySelector('[data-search-input]');
    var panelResults = panel.querySelector('[data-search-results]');

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      var isOpen = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) { setTimeout(function () { if (panelInput) panelInput.focus(); }, 50); }
      else if (panelResults) { clearResults(panelResults); }
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-search-panel]') && !e.target.closest('[data-search-toggle]')) {
        panel.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) {
        panel.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        if (panelResults) clearResults(panelResults);
        toggle.focus();
      }
    });
  }
}());

// ── Load more (collection page) ───────────────────────────────────────────────
(function () {
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-load-more]');
    if (!btn) return;
    e.preventDefault();
    // The trigger is an <a class="btn" data-load-more> (sections/main-collection.liquid),
    // so "disabled" is expressed with a class + aria-disabled, not the disabled property.
    if (btn.classList.contains('is-loading')) return;
    var url = btn.getAttribute('data-load-more') || btn.getAttribute('href');
    if (!url) return;
    var originalHTML = btn.innerHTML;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-disabled', 'true');
    btn.textContent = 'Loading…';
    try {
      var res = await fetch(url);
      if (!res.ok) throw new Error('Failed to load');
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = document.querySelector('.coll-grid-editorial');
      if (grid) {
        doc.querySelectorAll('.coll-grid-editorial > *').forEach(function (card) { grid.appendChild(card); });
      }
      // Keep the list / build-log view in step with the grid
      var listBody = document.querySelector('[data-view-list] tbody');
      if (listBody) {
        doc.querySelectorAll('[data-view-list] tbody > tr').forEach(function (row) { listBody.appendChild(row); });
      }
      // Wire up swatches (and any other card behaviours) on the newly added cards;
      // quick-add is delegated at document level so it needs no re-init.
      document.dispatchEvent(new CustomEvent('products:loaded'));
      // Swap in the fetched page's own trigger (it points at page N+1); when the
      // fetched page has no next page, remove the trigger entirely.
      var nextBtn = doc.querySelector('[data-load-more]');
      var wrap = btn.closest('.coll-load-more-wrap');
      if (nextBtn) {
        btn.replaceWith(nextBtn);
      } else if (wrap) {
        wrap.remove();
      } else {
        btn.remove();
      }
    } catch (err) {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-disabled');
      btn.innerHTML = originalHTML;
      console.error('Load more error:', err);
    }
  });
}());

// ── Collection sort flags keep the active filter params ───────────────────────
// The Liquid renders bare ?sort_by=… hrefs; merge each one into the current
// query string so sorting never discards filter.* params (and vice versa —
// the filter form carries sort_by server-side in main-collection.liquid).
(function () {
  var flags = document.querySelectorAll('.coll-sort-flags a[href*="sort_by="]');
  if (!flags.length) return;
  flags.forEach(function (a) {
    try {
      var target = new URL(a.getAttribute('href'), location.href);
      var sortBy = target.searchParams.get('sort_by');
      if (!sortBy) return;
      var merged = new URL(location.href);
      merged.searchParams.set('sort_by', sortBy);
      merged.searchParams.delete('page'); // a new sort order restarts pagination
      merged.hash = '';
      a.setAttribute('href', merged.pathname + merged.search);
    } catch (_) {}
  });
}());

// ── Header height CSS variable ────────────────────────────────────────────────
(function () {
  var hdr = document.querySelector('[data-header]');
  if (!hdr) return;
  function set() { document.documentElement.style.setProperty('--hdr-h', hdr.offsetHeight + 'px'); }
  set();
  window.addEventListener('resize', set, { passive: true });
}());

// ── Promo tiles (parallax shirt-image marketing, shuffled per view) ────────────
(function () {
  function cfg() {
    var el = document.getElementById('CCLPromo');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  window.cclPromoTileHTML = function (span) {
    var c = cfg(); if (!c) return '';
    var inner = '<div class="promo-tile-inner">' +
      (c.kicker ? '<div class="promo-tile-kicker">' + esc(c.kicker) + '</div>' : '') +
      '<div class="promo-tile-headline">' + esc(c.headline) + '</div>' +
      (c.subtext ? '<div class="promo-tile-sub">' + esc(c.subtext) + '</div>' : '') +
      '<span class="promo-tile-cta">' + esc(c.cta_label) + '</span></div>';
    return '<a class="promo-tile" data-promo-tile href="' + esc(c.cta_url || '/collections/all') +
      '" style="grid-column: span ' + span + ';" aria-label="' + esc(c.headline) + '">' +
      '<span class="promo-tile-bg" data-promo-bg aria-hidden="true"></span>' + inner + '</a>';
  };
  window.cclPromoInit = function () {
    var c = cfg();
    var imgs = (c && c.images ? c.images : []).filter(Boolean);
    if (!imgs.length) return;
    // Track images already used on this page so multiple tiles don't repeat the
    // same shot (refills once every image has been used). Still random per load.
    window._cclPromoUsed = window._cclPromoUsed || [];
    document.querySelectorAll('[data-promo-tile]:not([data-promo-ready])').forEach(function (el) {
      el.setAttribute('data-promo-ready', '1');
      var avail = imgs.filter(function (u) { return window._cclPromoUsed.indexOf(u) === -1; });
      if (!avail.length) { window._cclPromoUsed = []; avail = imgs.slice(); }
      var u = avail[Math.floor(Math.random() * avail.length)];
      window._cclPromoUsed.push(u);
      var bg = el.querySelector('[data-promo-bg]');
      if (bg) bg.style.backgroundImage = "url('" + u + "')";
      el.classList.add('has-img');
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.cclPromoInit);
  } else {
    window.cclPromoInit();
  }
}());

// ── Adjacent objects (related products) ─────────────────────────────────────
// [data-adjacent] carries the product's collections, most specific first.
// Each is fetched as /collections/<h>?sort_by=best-selling&sections=pdp-adjacent
// so cards arrive in best-selling order; the current product is skipped, ids
// are de-duplicated across collections, and we stop at data-limit. Falls back
// to Shopify's recommendations endpoint when no collection handles exist.
(function () {
  var sec = document.querySelector('[data-adjacent]');
  if (!sec) {
    // Older cached markup: fill the legacy recommendations placeholder instead.
    var old = document.getElementById('product-recommendations');
    if (old && old.getAttribute('data-url')) {
      fetch(old.getAttribute('data-url')).then(function (r) { return r.ok ? r.text() : Promise.reject(); }).then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html'); var sct = d.querySelector('[data-recommendations-section]');
        if (sct && sct.children.length) { old.replaceWith(sct); if (window.cclPromoInit) window.cclPromoInit(); } else old.remove();
      }).catch(function () { old.remove(); });
    }
    return;
  }
  var grid = sec.querySelector('[data-adjacent-grid]');
  var pid = sec.getAttribute('data-product-id');
  var limit = parseInt(sec.getAttribute('data-limit'), 10) || 4;
  var handles = (sec.getAttribute('data-collections') || '').split(',').filter(Boolean);

  function finish(cards) {
    if (!grid || !cards.length) return;
    var frag = document.createDocumentFragment();
    cards.forEach(function (c) { frag.appendChild(c); });
    if (window.cclPromoTileHTML && cards.length >= 3 && cards.length % 3 !== 0) {
      var wrap = document.createElement('div');
      wrap.innerHTML = window.cclPromoTileHTML(3 - (cards.length % 3));
      while (wrap.firstChild) frag.appendChild(wrap.firstChild);
    }
    var g = grid;
    if (g.id === 'product-recommendations') { g = document.createElement('div'); g.className = 'bento-grid'; grid.replaceWith(g); }
    g.innerHTML = '';
    g.appendChild(frag);
    if (window.cclPromoInit) window.cclPromoInit();
    if (window.cclInitSwatches) window.cclInitSwatches(g);
  }

  function legacy() {
    var url = grid && grid.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('[data-recommendations-section]');
        if (section && section.children.length) { grid.replaceWith(section); if (window.cclPromoInit) window.cclPromoInit(); }
        else if (!grid.children.length) grid.remove();
      })
      .catch(function () { if (grid && !grid.children.length) grid.remove(); });
  }

  if (!handles.length) { legacy(); return; }
  var picked = [], seen = {};
  seen[pid] = true;
  function step(i) {
    if (i >= handles.length || picked.length >= limit) return Promise.resolve();
    // Hourly cache-buster: Shopify caches section renders per exact URL, and a
    // URL first requested while the section was missing stays cached as null.
    return fetch('/collections/' + handles[i] + '?sort_by=best-selling&sections=pdp-adjacent&_=' + Math.floor(Date.now() / 3600000))
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (json) {
        var doc = new DOMParser().parseFromString(json['pdp-adjacent'] || '', 'text/html');
        doc.querySelectorAll('.pcard[data-product-id]').forEach(function (card) {
          var id = card.getAttribute('data-product-id');
          if (seen[id] || picked.length >= limit) return;
          seen[id] = true;
          picked.push(card);
        });
      })
      .catch(function () {})
      .then(function () { return step(i + 1); });
  }
  step(0).then(function () { if (picked.length) finish(picked); else legacy(); });
}());

// ── Product card color swatches ───────────────────────────────────────────────
(function () {
  var COLOR_MAP = {
    black: '#1a1a1a', white: '#f5f5f5', red: '#d63031', blue: '#2980b9',
    navy: '#1a2f5a', grey: '#888', gray: '#888', green: '#27ae60',
    yellow: '#f1c40f', pink: '#fd79a8', purple: '#8e44ad', orange: '#e67e22',
    brown: '#795548', tan: '#d4a057', beige: '#e8d5b7', cream: '#fffdd0',
    maroon: '#800000', heather: '#9a9a9a', charcoal: '#555', gold: '#f9a825',
    silver: '#bdbdbd', teal: '#009688', coral: '#ff6b6b', olive: '#6b7c2d',
    burgundy: '#800020', slate: '#607d8b', sand: '#d4b483', stone: '#b5a898',
    khaki: '#c3b091', rose: '#e8b4b8', mint: '#98d8c8', lavender: '#d8b4d8',
    magenta: '#c2185b', cyan: '#00acc1', indigo: '#3949ab', lime: '#7cb342',
    'solid black': '#1a1a1a', 'solid white': '#f5f5f5', 'dark gray': '#444',
    'light gray': '#ccc', 'heather gray': '#9a9a9a', 'royal blue': '#2962ff',
    'forest green': '#2e7d32', 'kelly green': '#4caf50',
  };

  function colorToCss(name) {
    var lower = name.toLowerCase();
    if (COLOR_MAP[lower]) return COLOR_MAP[lower];
    for (var key in COLOR_MAP) {
      if (lower.indexOf(key) !== -1) return COLOR_MAP[key];
    }
    return '#c8c8c8';
  }

  window.cclInitSwatches = initSwatches;
  function initSwatches(root) {
    (root || document).querySelectorAll('.pcard-swatches').forEach(function (container) {
      // Idempotent: never bind the same card twice (safe to re-run after AJAX)
      if (container.dataset.swatchInit === '1') return;
      container.dataset.swatchInit = '1';
      var card = container.closest('.pcard');
      var frontImg = card && card.querySelector('.pcard-img-front');
      var backImg = card && card.querySelector('.pcard-img-back');
      if (!frontImg) return;

      var origFrontSrc = frontImg.getAttribute('src') || '';
      var origFrontSrcset = frontImg.getAttribute('srcset') || '';
      var origBackSrc = backImg ? (backImg.getAttribute('src') || '') : '';
      var origBackSrcset = backImg ? (backImg.getAttribute('srcset') || '') : '';

      function applyImg(src) {
        frontImg.src = src;
        frontImg.removeAttribute('srcset');
        if (backImg) { backImg.src = src; backImg.removeAttribute('srcset'); }
      }

      function restoreImgs() {
        var active = container.querySelector('.pcard-swatch.is-active');
        var src = active ? active.dataset.img : '';
        if (src) {
          applyImg(src);
        } else {
          frontImg.src = origFrontSrc;
          if (origFrontSrcset) frontImg.setAttribute('srcset', origFrontSrcset);
          if (backImg) {
            backImg.src = origBackSrc;
            if (origBackSrcset) backImg.setAttribute('srcset', origBackSrcset);
          }
        }
      }

      container.querySelectorAll('.pcard-swatch').forEach(function (swatch) {
        swatch.style.setProperty('--swatch-bg', colorToCss(swatch.dataset.color || ''));

        swatch.addEventListener('mouseenter', function (e) {
          e.preventDefault();
          var src = swatch.dataset.img;
          if (src) applyImg(src);
        });

        swatch.addEventListener('mouseleave', function (e) {
          e.preventDefault();
          restoreImgs();
        });

        swatch.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          container.querySelectorAll('.pcard-swatch').forEach(function (s) { s.classList.remove('is-active'); });
          swatch.classList.add('is-active');
          var src = swatch.dataset.img;
          if (src) applyImg(src);
        });

        swatch.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); swatch.click(); }
        });
      });
    });
  }

  initSwatches();
  document.addEventListener('cart:refresh', function () { initSwatches(); });
  // Re-init when new product cards are injected (load-more, AJAX filtering, etc.)
  document.addEventListener('products:loaded', function () { initSwatches(); });
}());

// ── Recently viewed ───────────────────────────────────────────────────────────
(function () {
  var KEY = 'rv_products';
  var MAX = 6;

  var jsonEl = document.getElementById('ProductJson');
  if (jsonEl) {
    try {
      var p = JSON.parse(jsonEl.textContent);
      var rawSrc = typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image && p.featured_image.src) || '';
      var src = rawSrc ? rawSrc.replace(/^\/\//, 'https://').replace(/^http:\/\//, 'https://') : '';
      var entry = { handle: p.handle, title: p.title, price: p.price, image: src, url: p.url || '/products/' + p.handle };
      var list = [];
      try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (_) {}
      list = list.filter(function (i) { return i.handle !== entry.handle; });
      list.unshift(entry);
      if (list.length > MAX) list = list.slice(0, MAX);
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (_) {}
  }

  var rvEl = document.getElementById('recently-viewed');
  if (!rvEl) return;
  var list = [];
  try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (_) {}
  var currentHandle = rvEl.getAttribute('data-current');
  if (currentHandle) list = list.filter(function (i) { return i.handle !== currentHandle; });
  if (!list.length) { rvEl.remove(); return; }

  function rvImgSrc(raw) {
    if (!raw) return '';
    var url = raw.replace(/^\/\//, 'https://').replace(/^http:\/\//, 'https://');
    return url + (url.indexOf('?') !== -1 ? '&' : '?') + 'width=600';
  }

  var cols = Math.min(list.length, 4);
  var cards = list.map(function (p) {
    var price = p.price ? '$' + (p.price / 100).toFixed(2) : '';
    var imgSrc = rvImgSrc(p.image);
    return '<a href="' + p.url + '" class="pcard" style="background:var(--bg);">' +
      '<div class="pcard-media">' +
      (imgSrc ? '<img src="' + imgSrc + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy" class="pcard-img-front">' : '') +
      '</div>' +
      '<div class="pcard-meta"><div class="pcard-title">' + p.title + '</div>' +
      '<div class="mono pcard-price">' + price + '</div></div></a>';
  }).join('');

  var rvMod = list.length % cols;
  var rvLeftover = rvMod === 0 ? 0 : cols - rvMod;
  var rvPromo = '';
  if (rvLeftover > 0 && document.getElementById('CCLPromo') && window.cclPromoTileHTML) {
    rvPromo = window.cclPromoTileHTML(rvLeftover);
  }

  rvEl.outerHTML = '<section class="rv-section">' +
    '<h2 class="display" style="font-size:clamp(28px,3vw,40px); margin:0; line-height:.95;">Recently viewed</h2>' +
    '<div class="rv-grid" style="grid-template-columns:repeat(' + cols + ',1fr);">' + cards + rvPromo + '</div></section>';
  if (window.cclPromoInit) window.cclPromoInit();
}());


// ── Stat counter animation ────────────────────────────────────────────────────
(function () {
  var els = document.querySelectorAll('[data-count]');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      observer.unobserve(el);
      var raw = el.getAttribute('data-count');
      if (/^(19|20)\d{2}$/.test(raw)) { el.textContent = raw; return; }
      var m = raw.match(/^([^0-9]*)([0-9]+\.?[0-9]*)([^0-9]*)$/);
      if (!m) return;
      var prefix = m[1], target = parseFloat(m[2]), suffix = m[3];
      var isInt = Number.isInteger(target);
      var start = performance.now();
      var dur = 1100;
      (function step(now) {
        var t = Math.min((now - start) / dur, 1);
        var eased = 1 - Math.pow(1 - t, 3);
        var val = eased * target;
        el.textContent = prefix + (isInt ? Math.round(val) : val.toFixed(1)) + suffix;
        if (t < 1) requestAnimationFrame(step);
        else el.textContent = raw;
      }(start));
    });
  }, { threshold: 0.6 });
  els.forEach(function (el) { observer.observe(el); });
}());

// ── Custom cursor removed — native cursor restored ────────────────────────────

// ── Cart discount code + drawer order note ────────────────────────────────────
// Delegated, so both the cart page and the (re-rendered) drawer are covered.
(function () {
  function applyDiscount(scope) {
    var input = scope.querySelector('[data-discount-input]');
    if (!input) return;
    var code = (input.value || '').trim();
    if (!code) { input.focus(); return; }
    // Shopify applies the code to the session, then honours ?redirect=.
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/checkout');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-discount-apply]');
    if (!btn) return;
    e.preventDefault();
    var scope = btn.closest('[data-cart-discount]');
    if (scope) applyDiscount(scope);
  });

  // Enter inside the code field must not submit the surrounding cart form
  // (that would fire the cart update/checkout instead of applying the code).
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('[data-discount-input]');
    if (!input) return;
    e.preventDefault();
    var scope = input.closest('[data-cart-discount]');
    if (scope) applyDiscount(scope);
  });

  // Persist the drawer note as soon as focus leaves it, so a drawer re-render
  // (triggered by any quantity change) can't discard what was typed.
  document.addEventListener('change', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (!note) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note.value }),
    }).catch(function () {});
  }, true);
}());

// ── Back-in-stock notification form ───────────────────────────────────────────
// Now a native {% form 'customer' %} POST in main-product.liquid — the address
// is stored in Admin tagged back-in-stock + restock-<handle>. The former JS
// handler here intercepted the submit and faked a "queued [OK]" state without
// sending anything, discarding every lead; do not reintroduce it.

// ── PDP media video — respect reduced motion (no autoplay, expose controls) ──
(function () {
  if (!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
  document.querySelectorAll('.pdp-media video[autoplay]').forEach(function (v) {
    v.removeAttribute('autoplay');
    v.setAttribute('controls', '');
    try { v.pause(); } catch (e) {}
  });
}());

// ── Hero shuffling background video ───────────────────────────────────────────
(function () {
  function init() {
    var v = document.querySelector('.t-render-video');
    if (!v) return;

    var isSmall = window.matchMedia && !window.matchMedia('(min-width: 901px)').matches;

    // Phones/tablets (≤900px): poster still only. Never assign a source and
    // never call play() — the 2x2 product grid under the headline is what sells
    // there, and the clips are 4–12MB. The panel keeps the markup poster from
    // hero.liquid; nothing below this line runs on small screens.
    if (isSmall) { v.removeAttribute('autoplay'); return; }

    var list;
    try { list = JSON.parse(v.getAttribute('data-hero-videos') || '[]'); } catch (e) { list = []; }

    // Shopify generates a first-frame still for every uploaded video — use it as
    // the poster so the panel shows a real still (not black) while the mp4 buffers.
    // An explicit merchant poster (hero image setting) always wins; the baked-in
    // opener poster (data-auto-poster) may be overridden when the clip changes.
    var hasMerchantPoster = v.hasAttribute('poster') && !v.hasAttribute('data-auto-poster');
    function setPoster(url) {
      if (hasMerchantPoster) return;
      var m = (url || '').match(/^(.*)\/videos\/c\/o\/v\/([a-z0-9]+)\.mp4/i);
      if (m) v.setAttribute('poster', m[1] + '/files/preview_images/' + m[2] + '.thumbnail.0000000000.jpg');
    }

    // Respect reduced-motion — show the first clip's still instead of playing
    // (the markup opener may already be autoplaying, so pause it too)
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      v.removeAttribute('autoplay');
      try { v.pause(); } catch (e) {}
      if (list.length) setPoster(list[0]);
      return;
    }
    if (!list.length) return;

    // One clip per page view, looped for the whole visit — no mid-visit swaps.
    // The first view of a session opens with the pinned first clip (drop
    // opener); each reload/revisit advances to a random other clip. A new
    // session (sessionStorage cleared) starts at the opener again.
    var idx = 0;
    try {
      var seen = parseInt(sessionStorage.getItem('ccl-hero-views') || '0', 10) || 0;
      if (seen > 0 && list.length > 1) {
        var last = sessionStorage.getItem('ccl-hero-last');
        do { idx = 1 + Math.floor(Math.random() * (list.length - 1)); }
        while (list.length > 2 && list[idx] === last);
      }
      sessionStorage.setItem('ccl-hero-views', String(seen + 1));
      sessionStorage.setItem('ccl-hero-last', list[idx]);
    } catch (e) { /* storage blocked → always open with the pinned clip */ }

    // Where the browser plays HLS natively (Safari/iOS), point at Shopify's
    // 480p rendition instead of the progressive file — ~4MB rather than 5–12MB
    // for the same clip. Theme-asset clips have no HLS, so they pass through.
    var nativeHls = v.canPlayType && v.canPlayType('application/vnd.apple.mpegurl') !== '';
    var hlsFailed = false;
    function sourceFor(url) {
      if (!nativeHls || hlsFailed) return url;
      var m = (url || '').match(/\/videos\/c\/o\/v\/([a-z0-9]+)\.mp4/i);
      return m ? 'https://cdn.shopify.com/videos/c/vp/' + m[1] + '/' + m[1] + '.m3u8' : url;
    }

    function attempt() {
      var p = v.play();
      if (p && p.catch) p.catch(function () {/* blocked (Low Power Mode etc.) → poster + tap fallback */});
    }

    function play() {
      // Markup ships no src (see hero.liquid) — the first call here is what
      // starts the fetch; later calls only re-set it on error fallthrough
      var src = sourceFor(list[idx]);
      if (v.getAttribute('src') !== src) {
        setPoster(list[idx]);
        // iOS honours these as properties, not just markup attributes, and
        // preload must be raised off "none" or the element buffers nothing.
        v.muted = true; v.defaultMuted = true; v.playsInline = true;
        v.preload = 'auto';
        v.src = src;
        try { v.load(); } catch (e) {}
      }
      // With preload="none" readyState is 0 right after load(), and iOS rejects
      // play() on an unbuffered element — so wait for data before asking again.
      if (v.readyState >= 2) attempt();
      else {
        v.addEventListener('loadeddata', attempt, { once: true });
        v.addEventListener('canplay', attempt, { once: true });
      }
    }
    // If the chosen clip fails to load, fall through the rest (still looping)
    var attempts = 0;
    v.addEventListener('error', function () {
      // Some Chromium builds report HLS support they can't actually deliver —
      // retry this same clip as progressive mp4 before giving up on it.
      if (!hlsFailed && /\.m3u8/.test(v.getAttribute('src') || '')) {
        hlsFailed = true; play(); return;
      }
      if (++attempts >= list.length) return;
      idx = (idx + 1) % list.length; play();
    });

    // Click-to-play fallback (desktop only — small screens returned above).
    // Where a browser blocks muted autoplay (Safari with autoplay disabled, a
    // laptop in Low Power Mode), .t-render-video is pointer-events:none so a
    // click on the panel lands here; a real user gesture always satisfies the
    // autoplay policy.
    var panelEl = v.closest('.t-render');
    if (panelEl) {
      panelEl.addEventListener('click', function () {
        if (v.paused) { v.muted = true; play(); }
      });
    }

    play();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
}());

// ── Scan-bench parallax ───────────────────────────────────────────────────────
(function () {
  function init() {
    var section = document.querySelector('[data-scanbench]');
    if (!section) return;
    var stage = section.querySelector('.t-scanbench-stage');
    if (!stage) return;
    var grid = section.querySelector('.t-scanbench-grid');
    var tee = section.querySelector('.t-scanbench-tee');
    var reveal = section.querySelector('.t-scanbench-tee .reveal');
    var beam = section.querySelector('.t-scanbench-beam');
    var specimen = section.querySelector('.t-scanbench-specimen');
    var callouts = section.querySelectorAll('.t-scanbench-callout');
    var fore = section.querySelector('.t-scanbench-fore');
    var track = section.querySelector('.t-scanbench-track i');
    var readout = section.querySelector('[data-scanbench-readout]');

    function apply(p) {
      var vh = window.innerHeight || 800;
      stage.style.setProperty('--p', p.toFixed(4));
      // Background grid: slow upward drift
      if (grid) grid.style.transform = 'translateY(' + (p * -0.14 * vh).toFixed(1) + 'px)';
      // Ghost wordmark: large drift, centred at p=0.5
      if (specimen) specimen.style.transform = 'translate(-50%, calc(-50% + ' + ((0.5 - p) * 0.60 * vh).toFixed(1) + 'px))';
      // Specimen tee: gentle drift, centred at p=0.5
      if (tee) tee.style.transform = 'translate(-50%, calc(-50% + ' + ((0.5 - p) * 0.26 * vh).toFixed(1) + 'px))';
      // Analysed reveal — clip-path set directly (calc(var()) in clip-path is unreliable)
      if (reveal) reveal.style.clipPath = 'inset(0 0 ' + ((1 - p) * 100).toFixed(1) + '% 0)';
      // Scan beam rides the reveal edge
      if (beam) { beam.style.top = (p * 100).toFixed(1) + '%'; beam.style.opacity = (0.35 + p * 0.65).toFixed(2); }
      // Callouts drift at varied depths, centred at p=0.5
      callouts.forEach(function (co) {
        var d = parseFloat(co.style.getPropertyValue('--d')) || 0;
        co.style.transform = 'translateY(' + ((0.5 - p) * d * 4).toFixed(1) + 'px)';
      });
      // Foreground copy: subtle counter-drift
      if (fore) fore.style.transform = 'translateY(' + ((0.5 - p) * -0.10 * vh).toFixed(1) + 'px)';
      // Readout bar + percentage
      if (track) track.style.width = (p * 100).toFixed(1) + '%';
      if (readout) readout.textContent = String(Math.round(p * 100)).padStart(3, '0') + '%';
    }

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      apply(0.55);
      return;
    }

    var ticking = false, visible = true;
    function loop() {
      ticking = false;
      var rect = section.getBoundingClientRect();
      var vh = window.innerHeight;
      var p = Math.max(0, Math.min(1, -rect.top / Math.max(1, rect.height - vh)));
      apply(p);
    }
    window.addEventListener('scroll', function () {
      if (visible && !ticking) { requestAnimationFrame(loop); ticking = true; }
    }, { passive: true });
    window.addEventListener('resize', loop);
    // Only run the scroll loop while the section is on-screen
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) loop();
      }, { rootMargin: '200px 0px' });
      io.observe(section);
    }
    loop();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
}());

// ── PDP Terminal option-button click → sync hidden radio ──────────────────────
(function () {
  // Resolve the currently-selected variant from active option buttons and sync
  // hidden id input, add button, stock pill, gallery image and price. Shared by
  // the click handler and the on-load init (so a pre-highlighted size registers).
  function money(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  // Price markup mirroring sections/main-product.liquid: current price, then a
  // struck compare-at price and a [-NN%] badge only when the variant is on sale.
  // (Shopify's product JSON carries compare_at_price in cents, or null.)
  function priceHTML(variant, withBadge) {
    var html = '<span class="price-current">' + money(variant.price) + '</span>';
    var cmp = variant.compare_at_price;
    if (typeof cmp === 'number' && cmp > variant.price) {
      html += ' <s class="price-compare">' + money(cmp) + '</s>';
      if (withBadge) {
        var pct = Math.floor(((cmp - variant.price) / cmp) * 100);
        html += ' <span class="badge-sale">[-' + pct + '%]</span>';
      }
    }
    return html;
  }

  // Desktop .pdp-add and the mobile sticky [data-pdp-mobile-add] share one label
  // + disabled state. If add feedback ("Adding…"/"Added ✓") is mid-flight,
  // btnFeedback restores btn._origText when it ends — retarget that instead of
  // clobbering the feedback text.
  function syncAddBtn(btn, available) {
    if (!btn) return;
    var label = available ? '$ add --to=cart' : '$ sold_out';
    btn.disabled = !available;
    if (btn._origText) btn._origText = label; else btn.textContent = label;
  }

  function resolveVariant(form, opts) {
    if (!form) return;
    opts = opts || {};
    var productJson = document.getElementById('ProductJson');
    if (!productJson) return;
    try {
      var p = JSON.parse(productJson.textContent);
      var selected = {};
      form.querySelectorAll('.pdp-option').forEach(function (opt) {
        var active = opt.querySelector('.pdp-option-btn.is-active');
        if (active) selected[active.dataset.optionName] = active.dataset.optionValue;
      });
      var match = p.variants.find(function (v) {
        return p.options.every(function (oname, i) {
          var val = v['option' + (i + 1)];
          return !selected[oname] || selected[oname] === val;
        });
      });
      if (match) {
        var idInput = form.querySelector('input[name="id"]');
        if (idInput) idInput.value = match.id;
        syncAddBtn(form.querySelector('.pdp-add'), match.available);
        syncAddBtn(document.querySelector('[data-pdp-mobile-add]'), match.available);

        // Keep the stock pill (in_stock:NN / low / sold_out) in sync with the variant
        var stockEl = document.querySelector('[data-pdp-stock]');
        if (stockEl) {
          stockEl.classList.remove('out', 'low');
          if (!match.available) {
            stockEl.textContent = 'sold_out';
            stockEl.classList.add('out');
          } else {
            var tracked = match.inventory_management === 'shopify';
            var qty = match.inventory_quantity;
            if (tracked && typeof qty === 'number' && qty > 0) {
              stockEl.textContent = 'in_stock:' + (qty < 10 ? '0' + qty : qty);
              if (qty <= 5) stockEl.classList.add('low');
            } else {
              stockEl.textContent = 'in_stock';
            }
          }
        }

        // Switch the main gallery image to the selected variant's image.
        // Skipped on initial load so media position 1 (e.g. a product video)
        // stays in the stage; only user swatch clicks retarget the gallery.
        var pos = match.featured_media && match.featured_media.position;
        if (pos && !opts.skipGallery) {
          var idx = String(pos - 1);
          var gallery = document.querySelector('[data-pdp-gallery]');
          if (gallery) {
            gallery.querySelectorAll('[data-stage]').forEach(function (s) {
              s.classList.toggle('is-active', s.getAttribute('data-stage') === idx);
            });
            gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
              t.classList.toggle('is-active', t.getAttribute('data-thumb') === idx);
            });
          }
        }

        // Keep price (desktop + mobile sticky) in sync with the variant,
        // including the struck compare-at price and [-NN%] sale badge.
        if (typeof match.price === 'number') {
          var priceEl = document.querySelector('.pdp-price');
          if (priceEl) priceEl.innerHTML = priceHTML(match, true);
          var mPrice = document.querySelector('[data-pdp-mobile-price]');
          if (mPrice) mPrice.innerHTML = priceHTML(match, false);
        }
      }
    } catch (err) {}
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pdp-option-btn');
    if (!btn || btn.classList.contains('is-disabled')) return;
    e.preventDefault();
    var form = btn.closest('form');
    if (!form) return;
    // Mark active among siblings (keep aria-pressed in sync)
    var group = btn.parentElement;
    if (group) group.querySelectorAll('.pdp-option-btn').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    resolveVariant(form);
  });

  // On load, resolve the pre-highlighted size into the hidden id input
  function init() {
    var form = document.querySelector('.pdp-form');
    if (!form) return;
    // Sync aria-pressed with the server-rendered is-active state
    form.querySelectorAll('.pdp-option-btn').forEach(function (b) {
      b.setAttribute('aria-pressed', b.classList.contains('is-active') ? 'true' : 'false');
    });
    resolveVariant(form, { skipGallery: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
}());

// ── PDP description read-more (full copy stays in DOM for SEO) ─────────────────
(function () {
  function init() {
    document.querySelectorAll('[data-pdp-desc]').forEach(function (desc) {
      var toggle = desc.parentElement.querySelector('[data-pdp-desc-toggle]');
      if (!toggle) return;
      // Bind the click handler once
      if (toggle.dataset.descBound !== '1') {
        toggle.dataset.descBound = '1';
        toggle.addEventListener('click', function () {
          var expanded = desc.classList.toggle('is-expanded');
          desc.classList.toggle('is-clamped', !expanded);
          toggle.innerHTML = expanded
            ? 'read less <span class="pre" aria-hidden="true">−</span>'
            : 'read more <span class="pre" aria-hidden="true">+</span>';
        });
      }
      // Don't recompute once the user has expanded it
      if (desc.classList.contains('is-expanded')) return;
      // Clamp, then only keep the clamp + toggle if the content actually overflows
      desc.classList.add('is-clamped');
      if (desc.scrollHeight > desc.clientHeight + 4) {
        toggle.hidden = false;
      } else {
        desc.classList.remove('is-clamped');
        toggle.hidden = true;
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  // Re-evaluate after web fonts settle (line heights can shift)
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(init); }
}());

// ── PDP qty buttons ───────────────────────────────────────────────────────────
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pdp-qty button[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input[name="quantity"]');
    if (!input) return;
    var delta = parseInt(btn.dataset.qty, 10) || 0;
    var v = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
    input.value = v;
  });
}());

// ── Override: remove hidden attribute coupling on drawer/mobile-nav wraps ─────
(function () {
  function unhide() {
    var d = document.querySelector('[data-cart-drawer]');
    if (d && d.hasAttribute('hidden')) d.removeAttribute('hidden');
    var m = document.querySelector('[data-mobile-nav]');
    if (m && m.hasAttribute('hidden')) m.removeAttribute('hidden');
  }
  unhide();
  document.addEventListener('DOMContentLoaded', unhide);
  // Re-unhide after any class-change observation
  var mo = new MutationObserver(function (recs) {
    recs.forEach(function (r) {
      if (r.attributeName === 'hidden') {
        r.target.removeAttribute('hidden');
      }
    });
  });
  var d = document.querySelector('[data-cart-drawer]');
  if (d) mo.observe(d, { attributes: true, attributeFilter: ['hidden'] });
  var m = document.querySelector('[data-mobile-nav]');
  if (m) mo.observe(m, { attributes: true, attributeFilter: ['hidden'] });
}());

/* ── FAQ accordion ─────────────────────────────────────────── */
(function () {
  function initFaq() {
    document.querySelectorAll('.pdp-faq-q').forEach(function (btn) {
      if (btn.dataset.faqInit) return;
      btn.dataset.faqInit = '1';
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        btn.setAttribute('aria-expanded', String(!expanded));
        if (panel) {
          if (expanded) { panel.setAttribute('hidden', ''); }
          else { panel.removeAttribute('hidden'); }
        }
      });
    });
  }
  initFaq();
  document.addEventListener('DOMContentLoaded', initFaq);
}());

